(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name itecAdministracio.shared.document.directive:mntDocumentView
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
     <example module="shared.document">
       <file name="index.html">
        <itec-document-view></itec-document-view>
       </file>
     </example>
   *
   */
  angular
    .module('itecAdministracio.shared.document')
    .directive('admDocumentView', admDocumentView);

  function admDocumentView($cookies, $http, FileSaver, Blob, ConvertFactory) {
    return {
      restrict: 'E',
      scope: {
        idEntitat: '=',
        listDocuments: '=',
        showCut: '=?',
        showCopy: '=?',
        showPaste: '=?',
        showEdit: '=?',
        editFunction: '=?',
        showDelete: '=?',
        showUpload: '=?',
        labelConfirmDelete: '@?',
        labelListTitle: '@?',
        labelUploadTitle: '@?',
        labelEditTitle: '@?',
        labelVersionTitle: '@?',
        labelLogTitle: '@?',
        uploadEndFunction: '=?',
        baseUrlUpload: '=',
        controllerUrlUpload: '='
      },
      templateUrl: 'shared/document/adm-document-view-directive.tpl.html',
      replace: false,
      controllerAs: 'ctrl',
      controller: function (DataFactory, LogoFactory, $scope, $log, $filter, Notification, LocalStorage, $mdDialog, $document, AdmConstant) {
        var vm = this;
        vm.name = 'admDocumentView';

        vm.showCut = angular.isUndefined($scope.showCut) ? true : $scope.showCut;
        vm.showCopy = angular.isUndefined($scope.showCopy) ? true : $scope.showCopy;
        vm.showPaste = angular.isUndefined($scope.showPaste) ? true : $scope.showPaste;
        vm.showEdit = angular.isUndefined($scope.showEdit) ? true : $scope.showEdit;
        vm.editFunction = angular.isUndefined($scope.editFunction) ? function(){} : $scope.editFunction;
        vm.showDelete = angular.isUndefined($scope.showDelete) ? true : $scope.showDelete;
        vm.showUpload = angular.isUndefined($scope.showUpload) ? true : $scope.showUpload;
        vm.uploadEndFunction = angular.isUndefined($scope.uploadEndFunction) ? function(){} : $scope.uploadEndFunction;


        vm.date = new Date().getTime();
        //vm.listDocuments = $scope.listDocuments;
        vm.selectedDocuments = [];
        vm.errors = {};
        vm.mode = 0;
        vm.listMode = true;

        vm.labelConfirmDelete = angular.isUndefined($scope.labelConfirmDelete) ? 'SHARED_DOCUMENT_CONFIRM_DELETE_CONTENT' : $scope.labelConfirmDelete;
        vm.labelListTitle = angular.isUndefined($scope.labelListTitle) ? 'SHARED_DOCUMENT_LIST_TITLE' : $scope.labelListTitle;
        vm.labelUploadTitle = angular.isUndefined($scope.labelUploadTitle) ? 'SHARED_DOCUMENT_UPLOAD_TITLE' : $scope.labelUploadTitle;
        vm.labelEditTitle = angular.isUndefined($scope.labelEditTitle) ? 'SHARED_DOCUMENT_EDIT_TITLE' : $scope.labelEditTitle;
        vm.labelVersionTitle = angular.isUndefined($scope.labelVersionTitle) ? 'SHARED_DOCUMENT_VERSION_TITLE' : $scope.labelVersionTitle;
        vm.labelLogTitle = angular.isUndefined($scope.labelLogTitle) ? 'SHARED_DOCUMENT_LOG_TITLE' : $scope.labelLogTitle;


        vm.setSelected = setSelected;
        vm.downloadDocument = downloadDocument;
        vm.downloadDocuments = downloadDocuments;
        vm.deleteDocument = deleteDocument;
        vm.editDocument = editDocument;
        //vm.editDocuments = editDocuments;
        vm.changeListMode = changeListMode;
        vm.submitEditForm = submitEditForm;
        vm.tornar = tornar;
        //vm.refreshDocuments = refreshDocuments;

        vm.editForm = 'editFormDocuments';


        /*Moure a itec-gallery*/
        function setSelected(selected, id) {
          var index = vm.selectedDocuments.indexOf(id);        
          if (index < 0 && selected) {
            vm.selectedDocuments.push(id);
          } else if (index >= 0 && !selected) {
            vm.selectedDocuments.splice(index, 1);
          }
        }

        function changeListMode() {
          vm.listMode = !vm.listMode;
          vm.refreshDocuments();
        }

        function editDocument(id) {
          vm.editFunction(id);
        }

        function deleteDocument(id) {
          LogoFactory.delete($scope.idEntitat, id).then(function(){
            vm.uploadEndFunction();        
          }).catch(function(error){
            Notification.processError(error);
          });
        }

        function downloadDocuments() {
          if (vm.selectedDocuments.length > 0) {

            vm.listVersionDocuments = [];
            angular.forEach(vm.selectedDocuments, function(id) {
              var docAux = {};
              var aux = $filter('filter')($scope.listDocuments, {id : id}, true);
              if (!angular.isUndefined(aux) && aux.length > 0) {
                docAux = aux[0];  
              }
             
              vm.downloadDocument(docAux.id);
              
            });
          } else {
            $log.debug('No s\'ha seleccionat cap document');
          }
        }    

        function downloadDocument(id) {
          var url = AdmConstant.SERVER_PATH_ADMINISTRACIO_COMPLETE_API + 'entitats/' + $scope.idEntitat + '/logos/' + id + '/download';
          
          var headers = {};
          headers['x-api-version'] = AdmConstant.SERVER_ADMINISTRACIO_VERSION;
          headers['authsecurity'] = $cookies.get('authsecurity');

          $http.get(url, {headers: headers}).then(function(response){
            var blob = ConvertFactory.b64toBlob(response.data, response.headers('Content-Type'));
            FileSaver.saveAs(blob, response.headers('filename'));
          });
        }

        function SaveToDisk(fileURL, fileName) {
          // for non-IE
          if (!window.ActiveXObject) {
            var save = document.createElement('a');
            save.href = fileURL;
            save.target = '_blank';
            save.download = fileName || 'unknown';

            var event = document.createEvent('Event');
            event.initEvent('click', true, true);
            save.dispatchEvent(event);
            (window.URL || window.webkitURL).revokeObjectURL(save.href);
          }

          // for IE
          else if ( !! window.ActiveXObject && document.execCommand)     {
            var _window = window.open(fileURL, '_blank');
            _window.document.close();
            _window.document.execCommand('SaveAs', true, fileName || fileURL);
            _window.close();
          }
        }

        function tornar(newMode){
          vm.mode = newMode;
          vm.refreshDocuments();
        }

        function submitEditForm() {
          if (vm.editForm.$valid) {
            LogoFactory.update(vm.idEntitat, vm.listEditDocuments[0].id, vm.listEditDocuments[0]).then(function(){
              $log.debug('Document modificats, id: ' + vm.selectedDocuments);
              vm.tornar(0);
            }).catch(function(error){
              vm.errors = Notification.processError(error);
            });
          } else {
            $log.log('invalid');
          }
        }
      },
      link: function (scope, element, attrs) {
        /* jshint unused:false */
        /* eslint "no-unused-vars": [2, {"args": "none"}] */
      }
    };
  }
}());
